import React, {useCallback, useContext} from "react";
import {EditorContext, useEditorState} from "@tiptap/react";
import {Menu, MenuButton, MenuItem, MenuItems, Transition} from "@headlessui/react";
import {FaChevronDown, FaListOl, FaListUl} from "react-icons/fa";

const icons = {
    bulletList: <FaListUl className="rich-text-button-icon"/>,
    orderedList: <FaListOl className="rich-text-button-icon"/>,
};

const listTitles = {
    bulletList: "Lista com marcador",
    orderedList: "Lista numerada",
};

const isListActive = (editor, type) => !!editor?.isActive(type);

const ListButton = ({editor, type}) => {
    const isActive = useEditorState({
        editor,
        selector: ({editor}) => isListActive(editor, type),
    });

    const handleClick = useCallback((event) => {
        event.preventDefault();
        if (!editor || editor.isDestroyed) return;

        if (type === "bulletList") {
            editor.chain().focus().toggleBulletList().run();
        } else if (type === "orderedList") {
            editor.chain().focus().toggleOrderedList().run();
        }
    }, [editor, type]);

    return (
        <MenuItem>
            <button
                type="button"
                className={"rich-text-button" + (isActive ? " active" : "")}
                onMouseDown={(event) => event.preventDefault()}
                onClick={handleClick}
                title={listTitles[type]}
            >
                {icons[type]}
            </button>
        </MenuItem>
    );
};

const RichTextListDropdownMenuContent = ({editor, types}) => {
    const activeType = useEditorState({
        editor,
        selector: ({editor}) => {
            if (!editor) return null;
            return types.find((type) => isListActive(editor, type)) ?? null;
        },
    });

    const activeIcon = activeType
        ? icons[activeType]
        : <FaListUl className="rich-text-button-icon"/>;

    return (
        <Menu>
            <MenuButton type="button" className="rich-text-button" title="Listas">
                {activeIcon}
                <FaChevronDown className="rich-text-button-dropdown-small"/>
            </MenuButton>
            <Transition
                enter="transition ease-out duration-75"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
            >
                <MenuItems anchor="bottom" className="heading-dropdown">
                    {types.map((type) => (
                        <ListButton editor={editor} type={type} key={type}/>
                    ))}
                </MenuItems>
            </Transition>
        </Menu>
    );
};

const RichTextListDropdownMenu = ({types}) => {
    const {editor} = useContext(EditorContext);

    if (!editor || !editor.isEditable) return null;

    return <RichTextListDropdownMenuContent editor={editor} types={types}/>;
};

export default RichTextListDropdownMenu;
